"use client";

import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getSchoolHistoryList } from "@/store/controller/schoolHistory.controller";

const columnClass: Record<number, string> = {
  1: "sm:grid-cols-1",
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-4",
};

export function StatsBar() {
  const dispatch = useAppDispatch();
  const history = useAppSelector((state) => state.schoolHistory.list[0]);

  useEffect(() => {
    dispatch(getSchoolHistoryList({}));
  }, [dispatch]);

  const stats = history?.stats ?? [];
  if (stats.length === 0) return null;

  return (
    <div className="bg-green-800 border-b border-green-900">
      <div className={`max-w-7xl mx-auto px-4 grid grid-cols-2 ${columnClass[Math.min(stats.length, 4)]} divide-x divide-green-700`}>
        {stats.map((stat, index) => (
          <div key={index} className="text-center px-4 py-5">
            <div className="text-2xl sm:text-3xl font-extrabold text-yellow-400">{stat.value}</div>
            <div className="text-green-200 text-xs mt-0.5">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
